<template>
  <div v-show="isLoaded" class="dMixologiaHoney-container" v-observe-visibility="startAnimate">
    <h2 class="dSection-title" :class="{animate: animate}">
      Mixología
    </h2>
    <h2 class="dSection-subtitle" :class="{animate: animate}">
      Vuélvete mixólogo con strongbow y agrega un toque de ingredientes naturales para crear una experiencia nueva de sabor.
    </h2>
    <div class="dSection-videos">
      <div class="dLeft-col">
        <div id="videoHoney1" class="video-left"></div>
        <h3>STRONG BEE</h3>
        <h4>Transformamos la miel en una experiencia color carmesí con un panal que deslumbra por la presencia de notas muy mexicanas de sal con chapulín.</h4>
      </div>
      <div class="dRight-col">
        <div id="videoHoney2" class="video-right"></div>
        <h5>SMOKEY NEST</h5>
        <h6>El perfume del azafrán hace juego con el acidez de la manzana verde para contrastar la pulpa del higo que se marida con el ahumado hipnótico del romero.</h6>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Bowser from "bowser";
import YouTubePlayer from 'youtube-player';
import tagFunctions from "@/utils/tagFunctions.js";

let timer, percent = 0, quartileTime

export default {
  name: "D_MixologiaHoney",
  components: {},
  data() {
    return {
      video1: null,
      video2: null,
      animate: false,
      isSafari: false,
    };
  },
  computed: {
    ...mapGetters(["isLoaded"]),
  },
  methods: {
    startAnimate(isVisible) {
      if(isVisible) {
        this.animate=true
      }
    },
    record(event) {
      let currentTime = Math.round(event.target.getCurrentTime());
      percent = getPercent(event);
      if (currentTime == quartileTime) {
        tagFunctions.evVideoPush(
          event.target.getVideoData().title,
          "Reach",
          "25"
        );
      }
      if (currentTime == 2 * quartileTime) {
        tagFunctions.evVideoPush(
          event.target.getVideoData().title,
          "Reach",
          "50"
        );
      }
      if (currentTime == 3 * quartileTime) {
        tagFunctions.evVideoPush(
          event.target.getVideoData().title,
          "Reach",
          "75"
        );
      }
      if (currentTime == Math.round(event.target.getDuration() * 0.99)) {
        tagFunctions.evVideoPush(
          event.target.getVideoData().title,
          "Reach",
          "100"
        );
      }
      function getPercent(event) {
        return Math.round(
          (event.target.getCurrentTime() / event.target.getDuration()) * 100
        );
      }
    },
    onPlayerStateChange(event) {
      quartileTime = Math.round(event.target.getDuration() / 4);
      const getQuartile = () => {
        if (percent <= 25) return 25;
        else if (percent > 25 && percent <= 50) return 50;
        else if (percent > 50 && percent <= 75) return 75;
        else return 100;
      };
      if (event.data == window.YT.PlayerState.PLAYING) {
        tagFunctions.evVideoPush(event.target.getVideoData().title, "Play", getQuartile())
        timer = setInterval(() => {
          this.record(event);
        }, 1000);
      } else {
        clearInterval(timer);
      }
      if (event.data == window.YT.PlayerState.ENDED) {
        tagFunctions.evVideoPush(event.target.getVideoData().title, "Complete", getQuartile())
      }
      if (event.data == window.YT.PlayerState.PAUSED) {
        tagFunctions.evVideoPush(event.target.getVideoData().title, "Pause", getQuartile())
      }
    },
  },
  beforeMount() {
    const browser = Bowser.getParser(window.navigator.userAgent);
    if (browser.getBrowserName()=='Safari') {
      this.isSafari = true
    }
  },
  mounted(){
    this.video1 = YouTubePlayer('videoHoney1', {videoId: 'XTcWOsYFVcQ', width: '560', height: '315'})
    this.video1.on('stateChange', this.onPlayerStateChange)
    this.video2 = YouTubePlayer('videoHoney2', {videoId: 'dIJtpLdruHI', width: '560', height: '315'})
    this.video2.on('stateChange', this.onPlayerStateChange)
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";
@import "~@/styles/Honey/D_MixologiaHoney.scss";
</style>